import { MAP } from '@namespace/voice/map'

export default function voice() {
  window.addEventListener('load', () => {
    MAP.init()
  })
}
